import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { InfoCardItem } from './InfoCardItem.js';
import { GroupWrapper } from './styled.js';
export const InfoCard = memo(function InfoCard({ items, columns = 2, rounded, pending, dataTestId }) {
    const filteredItems = useMemo(() => items.filter((item) => item.value !== undefined && item.value !== null), [items]);
    if (filteredItems.length === 0) {
        return null;
    }
    return (_jsx(GroupWrapper, { $columns: columns, $rounded: rounded, "data-testid": dataTestId, children: filteredItems.map((item, index) => (_jsx(InfoCardItem, { ...item, pending: pending }, `${item.title}-${index}`))) }));
});
